import { queryJSON } from "../index";

var loginUrl = function loginUrl() {
  var queryParams = queryJSON();
  return queryParams.action === "login";
};

export { loginUrl };